'use strict';

module.exports = {
  // Ad ops uses this to measure users w/o js
  adOpsIframe: false,
  // Currently only enabled on author pages
  infiniteScrollAllFeed: true,
  // Video Permalinks Pages /video/slug/id
  videoPagesEnabled: true,
  // Ad on top of nav, marketing team test
  topNavAdEnabled: false,
  // Omniture replacement, adops test
  gaCustomVarEnabled: true,
  // newletter preferences page
  newsletterPreferencesPageEnabled: true,
  // Revcontent raw js widget
  revContentJSWidgetEnabled: true,
  // Dianomi widget
  dianomiStoriesEnabled: false,
  // fbia
  fbiaEnabled: true,
  // personalized recommendations widget on post pages
  postPersonalizedRecommendationsEnabled: true,
  // Lift igniter
  liftIgniterEnabled: false,
  fastlyCloudinaryFetchEnabled: true,
  rightRailPlayer: true,
  pmxMetrics: true
};



// WEBPACK FOOTER //
// ./feature_flags.js